import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
@Component({
  selector: 'app-success-box',
  templateUrl: './success-box.component.html',
  styleUrls: ['./success-box.component.css']
})
export class SuccessBoxComponent implements OnInit {
  msg=""
  title=""
  per=0
  type='success'
  constructor(public dialogRef: MatDialogRef<SuccessBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data,) { 
      this.msg=data.msg
      this.title=data.title
      if(data.type)
      this.type=data.type

    }

  ngOnInit() {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
